import { Component, Input, OnInit } from '@angular/core';
import { GeneralService } from '../../services/general/general.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent implements OnInit {
  @Input() type: any = 'teacher-calendar';
  @Input() sideNav: any = null;

  public isMobile: any;

  constructor(public general: GeneralService) {
    this.isMobile = this.general.isMobile();
  }

  ngOnInit(): void {}
}
